import { combineReducers } from 'redux';
import { alertReducer } from './alert/alert.reducers';
import { userLoginReducer, mentorRegisterReducer, studentRegisterReducer, userProfileReducer, userProfileUpdateReducer } from './user/user.reducers'
import { courseListReducer } from './course/course.reducers'
import { mentorListReducer } from './mentor/mentor.reducers';

const rootReducer = combineReducers({
    userLogin: userLoginReducer,
    mentorRegister: mentorRegisterReducer,
    studentRegister: studentRegisterReducer,
    userProfile: userProfileReducer,
    userProfileUpdate: userProfileUpdateReducer,
    courseList: courseListReducer,
    mentorList: mentorListReducer,
    alert: alertReducer
});

export default rootReducer;